import {devplus, nav_toggler, scroll_to_estate_form, scroll_to_links, scroll_to_zone_id} from './modules/common.js';
import cookie_consent from './modules/cookie_consent.js';
import collapsibles from './modules/collapsibles.js';

// doc ready
const dom_is_ready = ( callback ) => {

	if ( document.readyState !== 'loading' ) {

		callback();

	} else {

		document.addEventListener( 'DOMContentLoaded', callback );
	
	}

};

const search_forms = () => {

	// forms
	let searchforms = document.querySelectorAll( '.searchform' );

	if ( searchforms.length ) {

		searchforms.forEach( searchform => {

			let textfield = searchform.querySelector( '.searchform-field' );

			if ( textfield ) {

				searchform.addEventListener( 'submit', function( e ) {

					if ( textfield ) {

						textfield.focus();

						// niet versturen bij lege value.
						if ( textfield.value.trim().length === 0 ) {

							e.preventDefault();

						}

					}

				} );

				const is_top_search = textfield.closest( '.top-controls' );

				if ( is_top_search ) {

					textfield.addEventListener( 'focus', function( e ) {

						devplus.body.classList.add( 'top-search-in-focus' );

					} );

					textfield.addEventListener( 'blur', function( e ) {

						devplus.body.classList.remove( 'top-search-in-focus' );

					} );

				}

			}

		} );

	}

	// search error
	let search_error = document.querySelector( '.search-error-warning' );

	if ( search_error ) {

		let search_error_close = search_error.querySelector( '.close' );

		if ( search_error_close ) {

			search_error_close.addEventListener( 'click', function( e ) {

				search_error.remove();

			} );

		}

	}

};

let maps_module_promise;

const handle_maps_module_load_error = ( target, error ) => {

	console.error( 'The maps module could not be loaded.', error );

	if ( target.matches( '.estate-single-map' ) ) {

		target.querySelector( '.map' )?.classList.add( 'load-error' );

	} else {

		target.classList.add( 'maps-load-error' );

	}

	return false;

};

const load_maps_module = target => {

	// deel dezelfde import zolang de aparte maps chunk wordt ingeladen
	if ( ! maps_module_promise ) {

		maps_module_promise = import( './modules/maps.js' ).catch( error => {

			maps_module_promise = undefined;

			throw error;

		} );

	}

	target.classList.remove( 'maps-load-error' );

	return maps_module_promise.then( ( {
		default: maps
	} ) => {

		maps( target );

		return true;

	} ).catch( error => handle_maps_module_load_error( target, error ) );

};

dom_is_ready( () => {

	// voorzie een css class zodra minstens één touchinput beschikbaar is
	const has_touch_support = navigator.maxTouchPoints > 0 || window.matchMedia( '(any-pointer: coarse)' ).matches;

	devplus.body.classList.toggle( 'has-touch-support', has_touch_support );

	// toggle nav
	nav_toggler();

	// uitklap componenten (zoals onze nav)
	collapsibles();

	// scroll to links
	scroll_to_links();

	// estate form scroll to support
	scroll_to_estate_form();

	// auto naar zones scrollen als het id in de hash is meegegeven
	scroll_to_zone_id();

	// cookie consent
	cookie_consent();

	// search
	search_forms();

	// verwijder de sessionStorage voor de estate overview als we niet op de pand detail of overzicht zitten
	if ( ! document.querySelector( '.content-single-type-estate' ) && ! document.querySelector( '.content-estate-overview' ) ) {

		sessionStorage.removeItem( 'overview_filters' );

		// console.log( 'sessionStorage wissen' );

	}

	// werk de scrollstatus alleen bij wanneer nodig, zodat een stilstaande pagina geen layoutwerk blijft uitvoeren
	let scroll_frame = null;

	const check_scroll = () => {

		scroll_frame = null;

		const scrolled_class = 'scrolled';
		const is_scrolled = window.scrollY > 0;

		if ( document.body.classList.contains( scrolled_class ) !== is_scrolled ) {

			document.body.classList.toggle( scrolled_class, is_scrolled );

		}

	};

	const schedule_scroll_check = () => {

		if ( scroll_frame === null ) {

			scroll_frame = requestAnimationFrame( check_scroll );

		}

	};

	window.addEventListener( 'scroll', schedule_scroll_check, { passive: true } );
	// controleer ook ankerlinks en herstelde scrollposities bij laden of terugnavigeren
	window.addEventListener( 'load', schedule_scroll_check, { once: true } );
	window.addEventListener( 'pageshow', schedule_scroll_check );
	check_scroll();

	// als we scrollen over de bepaalde elementen, hide de floating nav
	if ( typeof window.IntersectionObserver !== 'undefined' ) {

		const floating_nav_targets_in_view = new Set();

		const floating_nav_view_hide_class = 'hide-floating-nav';

		let floating_nav_observer = new IntersectionObserver( ( entries ) => {

			entries.forEach( ( entry ) => {

				if ( entry.intersectionRatio > 0 || entry.isIntersecting ) {

					floating_nav_targets_in_view.add( entry.target );

				} else if ( ! entry.isIntersecting ) {

					floating_nav_targets_in_view.delete( entry.target );

				}

			} );

			devplus.body.classList.toggle( floating_nav_view_hide_class, floating_nav_targets_in_view.size > 0 );

		} );

		document.querySelectorAll( 'footer, .zone-form' ).forEach( ( floating_nav_target ) => {

			floating_nav_observer.observe( floating_nav_target );

		} );

	} else {

		// oudere browsers verbergen de zwevende navigatie via scroll- en resize-events
		const floating_nav_targets = Array.from( document.querySelectorAll( 'footer, .zone-form' ) );
		let floating_nav_frame;

		const update_floating_nav = () => {

			floating_nav_frame = null;
			const target_in_view = floating_nav_targets.some( target => {

				const rect = target.getBoundingClientRect();
				return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;

			} );

			devplus.body.classList.toggle( 'hide-floating-nav', target_in_view );

		};

		const schedule_floating_nav = () => {

			if ( ! floating_nav_frame ) {

				floating_nav_frame = requestAnimationFrame( update_floating_nav );

			}

		};

		window.addEventListener( 'scroll', schedule_floating_nav, { passive: true } );
		window.addEventListener( 'resize', schedule_floating_nav );
		window.addEventListener( 'load', schedule_floating_nav, { once: true } );
		update_floating_nav();

	}

	// dynamic imports hierna:

	// banner
	if ( document.querySelector( '.banner' ) ) {

			import( './modules/banner.js' ).then( ( {
				default: banner
			} ) => {

				banner();

			} );

	}

	// carousel
	if ( document.querySelector( '.carousel' ) ) {

		import( './modules/carousel.js' ).then( ( {
	      default: carousel
	    } ) => {

			carousel();

		} );

	}

	// image carousel
	if ( document.querySelector( '.image-carousel' ) ) {

		import( './modules/image-carousel.js' ).then( ( {
		  default: image_carousel
		} ) => {

			image_carousel();

		} );

	}

	// gallery
	if ( document.querySelector( '.gallery' ) ) {

		import( './modules/gallery.js' ).then( ( {
	       default: gallery
	     } ) => {

			gallery();

		} );

	}

	// estate overview
	if ( document.querySelector( '.content-estate-overview' ) ) {

		import( './modules/estate-overview.js' ).then( ( {
             default: estate_overview
         } ) => {

			estate_overview();

		} );

	}

	// estate single
	if ( document.querySelector( '.content-single-type-estate' ) ) {

		import( './modules/estate-single.js' ).then( ( {
			default: estate_single
        } ) => {

			estate_single();

		} );

	}

	// faq
	if ( document.querySelector( '#faq' ) ) {

		import( './modules/faq.js' ).then( ( {
           default: faq
       } ) => {

			faq();

		} );

	}

	// cf7 events, wanneer er formulieren zijn, via dynamic import
	if ( document.querySelectorAll( '.wpcf7' ).length ) {

		import( './modules/cf7.js' ).then( ( {
			default: cf7_init
		} ) => {

			cf7_init();

		} );

	}

	// laad de maps chunk pas wanneer de kleine kaart werkelijk in beeld komt
	const estate_single_map = document.querySelector( '.estate-single-map' );

	if ( estate_single_map ) {

		if ( typeof window.IntersectionObserver !== 'undefined' ) {

			const estate_single_map_observer = new IntersectionObserver( ( entries, observer ) => {

				entries.forEach( entry => {

					if ( entry.intersectionRatio > 0 || entry.isIntersecting ) {

						observer.unobserve( entry.target );
						load_maps_module( entry.target );

					}

				} );

			} );

			estate_single_map_observer.observe( estate_single_map );

		} else {

			load_maps_module( estate_single_map );

		}

	}

	// laad dezelfde chunk pas bij de eerste klik op een fullscreen-mapknop, zorg er ook voor dat de logica in estate-overview de listener niet kan weggooien.
	let fullscreen_map_is_loading = false;

	document.addEventListener( 'click', e => {

		const button = e.target instanceof Element
			? e.target.closest( 'button.estate-map-button' )
			: null;

		if ( ! button ) {

			return;

		}

		e.preventDefault();

		if ( fullscreen_map_is_loading || document.querySelector( '#estate-overview-map' ) ) {

			return;

		}

		fullscreen_map_is_loading = true;

		load_maps_module( button ).finally( () => {

			fullscreen_map_is_loading = false;

		} );

	} );

} );
